import { CiShoppingCart } from "react-icons/ci";
import { useFilters } from "../../context/FiltersContext";

const Navbar = () => {
  const {searchInput, setSearchInput} = useFilters();
  return (
    <nav className="navbar">
        <h1>Lumina Store</h1>
        <div className="navbar-links">
            <a className="navbar-link" href="/">Shop</a>
            <a className="navbar-link" href="/products">Account</a>
            <a className="navbar-link" href="/about">Contact Us</a>
        </div>
        <div>
            <input type="text" onChange={e => setSearchInput(e.target.value)} value={searchInput} placeholder="Search Products..." />
            <CiShoppingCart/>
        </div>
    </nav>
  );
}

export default Navbar;
